import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const labelColor = tone === 'dark' ? 'text-gold-light' : 'text-navy';
  const sepColor = tone === 'dark' ? 'text-gold-light' : 'text-navy';
  return <div className="flex flex-col items-center" role="timer" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-99" data-mp="3gymf432r4ccm">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-widest ${labelColor}`} data-id="element-100" data-mp="371zxro9mw3fc">
        <ClockIcon aria-hidden="true" className="h-4 w-4" data-id="element-101" data-mp="10dekfqcbl5v8" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-102" data-mp="15a4yy98h7tej">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-103" data-mp="y04zcbnfg0uq" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-104" data-mp="xytu07ec2l1i">
              <span className="flex h-[68px] w-[68px] items-center justify-center rounded-xl border border-gold/40 bg-navy font-serif text-4xl font-bold tabular-nums text-gold-light shadow-lg sm:h-20 sm:w-20 sm:text-5xl" data-id="element-105" data-mp="t120j8y1iqv7">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === 'dark' ? 'text-white/70' : 'text-ink-muted'}`} data-id="element-106" data-mp="f22i4j14f87h">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold sm:pt-5 ${sepColor}`} aria-hidden="true" data-id="element-107" data-mp="o4bpx1508nh6">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}